import {
  CREATE_SERVICE_REQUEST_FAIL,
  CREATE_SERVICE_REQUEST_REQUEST,
  CREATE_SERVICE_REQUEST_SUCCESS,
  DELETE_SERVICE_REQUEST_FAIL,
  DELETE_SERVICE_REQUEST_REQUEST,
  DELETE_SERVICE_REQUEST_SUCCESS,
  ARCHIVE_SERVICE_REQUEST_FAIL,
  ARCHIVE_SERVICE_REQUEST_REQUEST,
  ARCHIVE_SERVICE_REQUEST_SUCCESS,
  GET_SERVICE_REQUEST_FAIL,
  GET_SERVICE_REQUEST_REQUEST,
  GET_SERVICE_REQUEST_SUCCESS,
  APPROVE_SERVICE_REQUEST_FAIL,
  APPROVE_SERVICE_REQUEST_REQUEST,
  APPROVE_SERVICE_REQUEST_SUCCESS,
  REJECT_SERVICE_REQUEST_FAIL,
  REJECT_SERVICE_REQUEST_REQUEST,
  REJECT_SERVICE_REQUEST_SUCCESS,
} from "../../types/admin/serviceRequestTypes";

export const createServiceRequestReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_SERVICE_REQUEST_REQUEST:
      return {
        ...state,
        createServiceRequestLoading: true,
      };
    case CREATE_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        createServiceRequestLoading: false,
        createServiceRequestInfo: payload,
        createServiceRequestErrors: "",
      };
    case CREATE_SERVICE_REQUEST_FAIL:
      return {
        ...state,
        createServiceRequestLoading: false,
        createServiceRequestErrors: payload,
        createServiceRequestInfo: [],
      };
    default:
      return state;
  }
};

export const deleteServiceRequestReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case DELETE_SERVICE_REQUEST_REQUEST:
        return {
          ...state,
          deleteServiceRequestLoading: true,
        };
      case DELETE_SERVICE_REQUEST_SUCCESS:
        return {
          ...state,
          deleteServiceRequestLoading: false,
          deleteServiceRequestInfo: payload,
          deleteServiceRequestErrors: "",
        };
      case DELETE_SERVICE_REQUEST_FAIL:
        return {
          ...state,
          deleteServiceRequestLoading: false,
          deleteServiceRequestErrors: payload,
          deleteServiceRequestInfo: [],
        };
      default:
        return state;
    }
  };
  

export const archiveServiceRequestReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case ARCHIVE_SERVICE_REQUEST_REQUEST:
        return {
          ...state,
          archiveServiceRequestLoading: true,
        };
      case ARCHIVE_SERVICE_REQUEST_SUCCESS:
        return {
          ...state,
          archiveServiceRequestLoading: false,
          archiveServiceRequestInfo: payload,
          archiveServiceRequestErrors: "",
        };
      case ARCHIVE_SERVICE_REQUEST_FAIL:
        return {
          ...state,
          archiveServiceRequestLoading: false,
          archiveServiceRequestErrors: payload,
          archiveServiceRequestInfo: [],
        };
      default:
        return state;
    }
  };

  export const getServiceRequestReducer = (state = {}, action) => {
      const { type, payload } = action;
      switch (type) {
        case GET_SERVICE_REQUEST_REQUEST:
          return {
            ...state,
            getServiceRequestLoading: true,
          };
        case GET_SERVICE_REQUEST_SUCCESS:
          return {
            ...state,
            getServiceRequestLoading: false,
            getServiceRequestInfo: payload,
            getServiceRequestErrors: "",
          };
        case GET_SERVICE_REQUEST_FAIL:
          return {
            ...state,
            getServiceRequestLoading: false,
            getServiceRequestErrors: payload,
            getServiceRequestInfo: [],
          };
        default:
          return state;
      }
    };

    

  export const approveServiceRequestReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case APPROVE_SERVICE_REQUEST_REQUEST:
        return {
          ...state,
          approveServiceRequestLoading: true,
        };
      case APPROVE_SERVICE_REQUEST_SUCCESS:
        return {
          ...state,
          approveServiceRequestLoading: false,
          approveServiceRequestInfo: payload,
          approveServiceRequestErrors: "",
        };
      case APPROVE_SERVICE_REQUEST_FAIL:
        return {
          ...state,
          approveServiceRequestLoading: false,
          approveServiceRequestErrors: payload,
          approveServiceRequestInfo: [],
        };
      default:
        return state;
    }
  };


  
  export const rejectServiceRequestReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case REJECT_SERVICE_REQUEST_REQUEST:
        return {
          ...state,
          rejectServiceRequestLoading: true,
        };
      case REJECT_SERVICE_REQUEST_SUCCESS:
        return {
          ...state,
          rejectServiceRequestLoading: false,
          rejectServiceRequestInfo: payload,
          rejectServiceRequestErrors: "",
        };
      case REJECT_SERVICE_REQUEST_FAIL:
        return {
          ...state,
          rejectServiceRequestLoading: false,
          rejectServiceRequestErrors: payload,
          rejectServiceRequestInfo: [],
        };
      default:
        return state;
    }
  };